(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('ReadUnreadController', readUnread);

  readUnread.$inject = ['$http', '$state', 'AuthenticationService', '$rootScope', 'CompanyService', 'NotificationService'];

  function readUnread ($http, $state, AuthenticationService, $rootScope, CompanyService, NotificationService) {
    $rootScope.getPageLabels('menu.config.readUnread');

    var vmReadUnreadCtrl = this;

    CompanyService
      .loadMetadata()
      .$promise
      .then(function (data) {
        vmReadUnreadCtrl.metadata = data;
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, $rootScope.labels.errorLoadMeta);
      });

    vmReadUnreadCtrl.allow = function () {
      CompanyService
        .saveMetadata(vmReadUnreadCtrl.metadata)
        .$promise
        .then(function (data) {
          $rootScope.company_metadata = data;
          NotificationService.successHandler(data, $rootScope.labels.saveConfig);
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorConfig);
        });
    };
  }
})();
